import React from "react";
import { Typography, Link, makeStyles } from "@material-ui/core";
import { useAppState } from "../../state";
import DCXLogo from "../DCXLogo";

const useStyles = makeStyles(theme => ({
  footerContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "1rem",
    color: theme.palette.text.secondary,
    padding: theme.spacing(1, 0)
  },
  links: {
    display: "flex",
    justifyContent: "center",
    gap: theme.spacing(1),
    alignItems: "center",
    marginBottom: theme.spacing(1),
    flexWrap: "wrap"
  },
  footerBrand: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    color: theme.palette.text.secondary
  },
  footerLogo: {
    display: "inline-flex",
    alignItems: "center",
    "& svg": {
      height: 20,
      width: "auto",
      display: "block"
    }
  }
}));

export default function Footer() {
  const classes = useStyles();
  const { clientID, locationID } = useAppState();

  const cid = encodeURIComponent(clientID || "");
  const lid = encodeURIComponent(locationID || "");
  const base = "https://console.drivebusinessintelligence.com/surveys/cec";
  const privacy = `${base}/privacy_policy.php?ClientID=${cid}&SurveyID=1&LocationID=${lid}`;
  const terms = `${base}/terms.php?ClientID=${cid}&SurveyID=1&LocationID=${lid}`;

  return (
    <div className={classes.footerContainer}>
      <div className={classes.links}>
        <Link href={privacy} target="_blank" rel="noopener noreferrer">
          Privacy Policy
        </Link>
        <Link href={terms} target="_blank" rel="noopener noreferrer">
          Terms of Service
        </Link>
      </div>
      <div className={classes.footerBrand}>
        <span className={classes.footerLogo}>
          <DCXLogo />
        </span>
        <Typography variant="caption">Drive CX USA Corp.</Typography>
      </div>
    </div>
  );
}
